export enum Environments {
  LOCAL = 'LOCAL',
  DEVELOPMENT = 'DEV',
  STAGING = 'STAGING',
  SANDBOX = 'SANDBOX',
  PRODUCTION = 'PRODUCTION',
}

export enum NodeEnvironments {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export const ENV_VARS = {
  environment: import.meta.env.VITE_ENVIRONMENT as Environments,
  node: import.meta.env.NODE_ENV as NodeEnvironments,
  release: import.meta.env.VITE_RELEASE,
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN_BACKOFFICE,
  },
  clarity: {
    projectId: import.meta.env.VITE_CLARITY_PROJECT_ID_BACKOFFICE,
  },
  mid: {
    templateUrl: import.meta.env.VITE_IMPORT_MID_TEMPLATE_URL,
  },
  bucket: {
    url: import.meta.env.VITE_BUCKET_URL,
  },
  swan: {
    linkUrl: import.meta.env.VITE_SWAN_LINK_URL,
  },
  growthbook: {
    apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
    clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  },
  googleMaps: {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
  },
} as const;
